export default [
    {
        component: () => import(/* webpackChunkName: 'cadastro-ferida' */ '@/views/cadastro/ferida/Index'),
        path: 'ferida',
        redirect: 'ferida/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'cadastro-ferida' */ '@/views/cadastro/ferida/List.vue'),
                name: 'cadastro-ferida-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-ferida' */ '@/views/cadastro/ferida/Form.vue'),
                name: 'cadastro-ferida-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-ferida' */ '@/views/cadastro/ferida/Form.vue'),
                name: 'cadastro-ferida-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]